// Frontend\src\component\demodashboard\flowdesigners\nodes\ReviewNode.jsx
import { Handle, Position } from "reactflow";

export default function ReviewNode({ selected, data }) {
  const status = data?.status || "idle";
  const isSelected = selected === true;

  const isVisuallyRunning = status === "running" || isSelected;

  const baseStyles = {
    idle: { borderColor: "#ccc", boxShadow: "none" },
    running: { borderColor: "#f97316", boxShadow: "0 0 20px rgba(249, 115, 22, 0.8)" },
    done: { borderColor: "#22c55e", boxShadow: "0 0 14px rgba(34, 197, 94, 0.5)" },
  };

  const currentStyle = status === "done"
    ? baseStyles.done
    : isVisuallyRunning
      ? baseStyles.running
      : baseStyles.idle;

  return (
    <div
      style={{
        padding: 12,
        borderRadius: 8,
        background: "#fff",
        border: isSelected ? "4px solid #2563eb" : `3px solid ${currentStyle.borderColor}`,
        boxShadow: isSelected
          ? `0 0 0 5px rgba(37, 99, 235, 0.3), ${currentStyle.boxShadow}`
          : currentStyle.boxShadow,
        transition: "all 0.4s ease",
        position: "relative",
        minWidth: 180,
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Bottom} />

      <strong>Review Email</strong>
      <div style={{ fontSize: 12, marginTop: 6, color: "#374151" }}>
        Preview generated content
      </div>
    </div>
  );
}